import { Component, OnInit } from '@angular/core';
import { NotificacionesService } from '../../services/notificaciones/notificacionesService';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-mis-mensajes',
    templateUrl: './mis-mensajes.component.html',
    styleUrls: ['./mis-mensajes.component.scss']
})
export class MisMensajesComponent implements OnInit {
    loading = false;
    mensajes: any[] = [];
    selectedMensaje: any = null;
    unreadCount = 0;

    constructor(
        private notificacionesService: NotificacionesService,
        private snack: MatSnackBar
    ) {}

    async ngOnInit() {
        await this.cargarMensajes();
    }

    async cargarMensajes() {
        this.loading = true;
        try {
            this.mensajes = await this.notificacionesService.getMisMensajes();
            this.unreadCount = this.mensajes.filter(m => !m.leido).length;
        } catch (error) {
            console.error('Error cargando mensajes:', error);
            this.snack.open('Error al cargar mensajes', 'Cerrar', { duration: 3000 });
        } finally {
            this.loading = false;
        }
    }

    async seleccionarMensaje(m: any) {
        this.selectedMensaje = m;
        if (!m.leido) {
            try {
                await this.notificacionesService.marcarComoLeidaSegura(m._id);
                m.leido = true;
                this.unreadCount = this.mensajes.filter(x => !x.leido).length;
                window.dispatchEvent(new CustomEvent('unread-messages-updated'));
            } catch (error) {
                console.error('Error marking message as read:', error);
            }
        }
    }

    volverAlListado() {
        this.selectedMensaje = null;
    }
}
